<template>
    <div class="lmy-home-page">
        <div class="lmy-content" v-for="list in hotelList">
            <div class="cityName">
                <i class="icon iconfont icon-lmy-dingwei"></i>
                <div class="txt">{{list.city}}</div>
                
            </div>
            <div class="lmy-content-c">
                <div class="hotel-list">
                  <div class="list-item" v-for="hotel in list.list" @click="routeToDetails(hotel,1)">
                    <div class="hotel-img">
                      <p>龙猫精选</p>
                      <img :src="hotel.Pics[0].Url|replaceImgSrc(4)" v-if="hotel.Pics&&hotel.Pics[0]" alt="">
                      <img src="./../../assets/img/hotelDetailsDf.png" v-if="!hotel.Pics||!hotel.Pics[0]||hotel.Pics[0].Url=='/'" alt="">
                    </div>
                    <div class="hotel-content">
                      <h5 class="title">{{hotel.HotelName}}</h5>
                      <label class="hotel-label">{{hotel.CommRate}}分</label>&nbsp;<label class="hotel-label">{{hotel.Evaluation}}&nbsp;|&nbsp;{{hotel.DistrictName}}&nbsp;{{hotel.Landmark}}</label>
                      <div class="price"><span class="one">￥{{hotel.LowestPrice}}</span> 起</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="no-more">
		    没有更多了...
		</div>	
    </div>
</template>
<script>
export default {
  name: "four_puls",
  data() {
    return {
      hotelList: [],
      HotelIDs: [764532, 920939, 920578, 406238, 463245, 119765]
    };
  },
  methods: {
    //进入酒店详情页
    routeToDetails(item, from) {
      var obj = {
        HotelID: item.ID,
        ProductType: 0,
        From: from,
        CheckIn: this.getDate(0),
        CheckOut: this.getDate(1),
        RoomCount: 1,
        AdultCount: 2,
        ChildrenCount: 0,
        ChildrenAges: [5, 5],
        MyCityRegionID: ""
      };
      this.dao.set("hotelDetailsParams", JSON.stringify(obj));
      this.saveHotelToHistory(item, from);
      this.$router.push("/hotelDetails");
    },
    //保存到历史记录
    saveHotelToHistory(hotel, from) {
      var list = this.dao.get("hotelViewHistory")
        ? JSON.parse(this.dao.get("hotelViewHistory"))
        : [];

      if (list && list.length > 0) {
        list.forEach((item, index) => {
          if (item.ID == hotel.ID) {
            list.splice(index, 1);
          }
        });
        hotel["From"] = from;
        hotel["date"] = new Date();
        list.unshift(hotel);
      } else {
        hotel["From"] = from;
        hotel["date"] = new Date();
        list.unshift(hotel);
      }
      this.dao.set("hotelViewHistory", JSON.stringify(list));
    },
    initData() {
      var params = {
        RegionID: "",
        From: 1,
        ProductType: 0,
        Name: "",
        Landmark: "",
        Star: "",
        PriceMin: "",
        PriceMax: "",
        CheckIn: this.getDate(0),
        CheckOut: this.getDate(1),
        RoomCount: 1,
        AdultCount: 2,
        ChildrenCount: 0,
        ChildrenAges: [5, 5],
        Page: 1,
        PageSize: 10,
        HotelIDs: this.HotelIDs,
        Sort: 0,
        MyLat: "",
        MyLon: "",
        Radius: "",
        MyCityRegionID: ""
      };
      this.postRequest({
        url: this.Api.price,
        params: params
      }).then(res => {
        if (res && res.IsSuccess && res.Result.length > 0) {
          var data = res.Result;
          var Sarr = [];
          var Darr = [];
          data.forEach(item => {
            if (item.CityID == "2007") {
              Darr.push(item);
            } else if (item.CityID == "2003") {
              Sarr.push(item);
            }
          });
          this.hotelList = [
            {
              city: "深圳",
              list: Sarr
            },
            {
              city: "东莞",
              list: Darr
            }
          ];
        }
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style scoped>
.cityName {
  display: flex;
  align-items: baseline;
  margin: 2px;
  padding-top: 10px;
  border-bottom: 1px solid #d2b47a;
}
.txt {
    font-size: 0.34rem;
    font-weight: bold;
}
.no-more {
  text-align: center;
  color: #a1a1a1;
}
</style>



// WEBPACK FOOTER //
// src/components/Four_puls/Four_puls.vue